/*
 * 詳細表示のベース実装
 */
<script>
/**
 * 詳細表示のベース実装
 * @vuedoc
 * @exports js/common/viewParamBase
 */
export default {
	mixins: [
		// マネージャーインスタンスアクセス
		require('js/common/vuex/manager/read.mixin.vue'),
	],
	props:[
		'r_func',
		'r_messages',
		'r_settings',
		'r_is_new',
		'r_code',
		'r_code2',
		'r_code_name',		//!< r_code を info に適用するための属性名
		'r_code2_name',		//!< r_code2 を info に適用するための属性名
		'r_class_code',
		'r_class_name',
		'r_info',
		'r_type',
	],
	data:function (){
		return{
			m_strCode:"",
			m_strCode2:"",
			m_info: null,
			m_infoBefore:{},	// 変更前データ
			m_bSetBefore:true,
			m_isInit: true,
			m_type: this.r_type?this.r_type:0, //!< 検索画面type
			m_bCopy:false,		//!< コピーフラグ

			m_preCopyInfo: null,

			m_bRestoreApplicantComment: false, // 承認者コメントを再適用するかどうか
			m_strApplicantComment: '', // 退避用承認者コメント
			m_strDateFrom: '', // 退避用適用日From
			m_strDateTo: '', // 退避用適用日To

			m_isEmptyCode: true, // キーとなるコードが入力済みかどうか
		};
	},
	created: function () {
		this.m_isInit = true;
		// 複製を作成
		this.m_strCode = this.r_code;
		this.m_strCode2 = this.r_code2;

		this.m_bCopy = false;
		this.m_info = $.extend(true,{},this.r_info);
		// this.m_infoBefore = $.extend(true,{},this.r_info);

		this.onUpdateSrcData();
console.log("[ viewParamBase - created ]");
console.log(this.m_info);
	},
	computed:{
		/**
		 * 呼び出しコードマックスミニマム取得
		 */
		search_default_codes:function(){
			var codes ={ max:0, min:0 };
			if(this.manager){
				var codes = this.manager.getMaxMinCodes(this.m_type);
			}
			return { code_max:codes.max, code_min:codes.min };
		},
		/**
		 * 呼び出し名称マックス取得
		 */
		search_default_name_max:function(){
			var nameMax = 100;
			if (this.manager) {
				nameMax = this.manager.getNameMax(this.m_type);
			}
			return nameMax;
		},
		//! コピー元選択によりコピーされた
		is_copy:function(){
			return this.m_bCopy;
		}
	},
	watch:{
		// データの切り替わり
		r_info: function(val){
			this.onWatchInfo(val);
		},
		//! 新規と既存データの切り替わりタイミング
		r_is_new: function(val){
			this.doRIsNewChange(val)
			this.clearMessage();
			// ユーザー編集データをクリアする
			this.m_info = $.extend(true,{},this.r_info);
			this.onUpdateSrcData();
			this.$nextTick(function() {
				//! データ更新フラグの更新
				// refsに関数内でアクセスするため、DOMに画表された後に行う
				this.updateChangeDataFlag();
			});
		},
		m_isInit: function(val){
			if ( !val ) {
				// 初期化処理が終わっている。
				console.log("[ watch m_isInit ]");
				this.$emit("event_end_copy_info");
			}
		},
		r_type: function(val){
			this.m_type = this.r_type;
		},
	},
	methods: {
		onSrcChange:function(val){
		},
		doRIsNewChange:function(val){
		},
		onEndCopyInfo:function(){
			this.m_isInit = false;
		},
		//! コピー元選択用の更新処理。強制的に編集データを更新する
		updateInfo:function(info, bCopy){
console.log("viewParamBase - updateInfo : copy=" + bCopy );
console.log(info);
			this.clearMessage();
			this.m_info = $.extend(true,{},info);
			if(bCopy){// コピーフラグ
				this.m_bCopy = true
			}

			this.onUpdateSrcData();
		},
		//! 初期化時の更新処理。強制的に編集データを更新する
		updateCode:function(code1, code2){
			this.m_strCode = code1;
			this.m_strCode2 = code2;
		},
		// 更新用のデータなので、code を info に適用して返す
		getData : function(){
			/**/
			if(this.r_code_name){
				this.m_info[this.r_code_name] = this.m_strCode;
			}
			if(this.r_code2_name){
				this.m_info[this.r_code2_name] = this.m_strCode2;
			}
			return this.m_info;
		},
		/**
		 * 拡張データを返す
		 */
		getExtraData : function(){
			return null;
		},
		/**
		 * 呼び出しコード変更
		 */
		onCodeChange: function(val){
			console.log("onCodeChange : " + val);
			if (this.r_code == '' && this.m_info.applicant_comment) {
				// コード未入力からの変更の場合、申請者コメントを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strApplicantComment = this.m_info.applicant_comment;
			}
			if (this.r_code == '' && this.m_info.date_from) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateFrom = this.m_info.date_from;
			}
			if (this.r_code == '' && this.m_info.date_to) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateTo = this.m_info.date_to;
			}
			this.$emit("event_code_change",val);
		},
		/**
		 * 
		 */
		onCodeChange2: function(val, flg){
			console.log("onCodeChange2 : " + val);
			if (this.r_code2 == '' && this.m_info.applicant_comment) {
				// コード2未入力からの変更の場合、申請者コメントを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strApplicantComment = this.m_info.applicant_comment;
			}
			if (this.r_code2 == '' && this.m_info.date_from) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateFrom = this.m_info.date_from;
			}
			if (this.r_code2 == '' && this.m_info.date_to) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateTo = this.m_info.date_to;
			}
			this.$emit("event_code_change2", val, flg);
		},
		/**
		 * コピー元選択
		 */
		onBtnCopySearch: function(){
			console.log("onBtnCopySearch");
			this.m_preCopyInfo = $.extend(true,{},this.m_info);
			this.$emit('event_btn_copysearch');
		},
		/**
		 * 空き番号検索ボタン
		 */
		onBtnFreeNumSearch: function(val){
			console.log("onBtnFreeNumSearch");
			if (this.r_code == '' && this.m_info.applicant_comment) {
				// コード未入力からの変更の場合、申請者コメントを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strApplicantComment = this.m_info.applicant_comment;
			}
			if (this.r_code == '' && this.m_info.date_from) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateFrom = this.m_info.date_from;
			}
			if (this.r_code == '' && this.m_info.date_to) {
				// コード未入力からの変更の場合、適用日fromを退避
				this.m_bRestoreApplicantComment = true;
				this.m_strDateTo = this.m_info.date_to;
			}
			this.$emit("event_btn_freenumsearch",val);
		},
		/**
		 * エラーメッセージ更新イベント
		 */
		onErrMessage:function(val){
			this.$emit("event_errmessage",val);
		},
		/*
		 * クローズイベント <br>
		 * ******* 内部処理 *******<br>
		 * event_closeでイベントを受け取り、引数がfalseならonBtnClose()を呼ぶ。 <br>
		 *
		 * @function  onClose
		 * @param {bool} is - クローズフラグ
		 * @instance
		 */
		onClose: function( is ){
			this.$emit('event_close', is);
		},
		/**
		 * キーアップイベント <br>
		 * ******* 内部処理 *******<br>
		 * keyupでイベントを受け取り、onBtnClose()を呼ぶ。 <br>
		 *
		 * @function onKeyup
		 * @param {object} e - イベントオブジェクト
		 * @instance
		 */
		onKeyup: function( e ){
		 	this.$emit('keyup', e);
		},
		/**
		 * データ変更フラグを更新する <br>
		 * ******* 内部処理 *******<br>
		 *  <br>
		 *
		 * @function updateChangeDataFlag
		 * @instance
		 */
		updateChangeDataFlag:function(){

		},
		/**
		 * 変更前データを取得 <br>
		 * ******* 内部処理 *******<br>
		 * 新規の場合は空文字を返す。 <br>
		 *
		 * @function getOldDataCode
		 * @param {String[]} data - 文字列
		 * @return {String[]} data - 文字列
		 * @instance
		 */
		getOldDataCode:function( data ){
			if (this.r_is_new) {
				return "";
			} else {
				return data;
			}
		},
		/**
		 * 変更前データを取得 <br>
		 * ******* 内部処理 *******<br>
		 * 新規の場合は空文字を返す。 <br>
		 *
		 * @function getOldDataSystemCode
		 * @param {String[]} data - 文字列
		 * @return {String[]} data - 文字列
		 * @instance
		 */
		getOldDataSystemCode:function( data ){
			if (this.r_is_new) {
				return -2;
			} else {
				return data;
			}
		},
		/**
		 * 編集されたデータがあるかチェック ※必要に応じてオーバーライド <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function checkUpdate
		 * @return {Boolean} チェック結果
		 * @instance
		 */
		checkUpdate:function(){
			return false;
		},
		/**
		 * バリデーションチェック ※必要に応じてオーバーライド <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function validate
		 * @return {Boolean} チェック結果
		 * @instance
		 */
		validate:function(){
			return true;
		},
		/**
		 * コードのバリデーションチェック ※必要に応じてオーバーライド <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function validateCode
		 * @return {Boolean} チェック結果
		 * @instance
		 */
		validateCode:function(){
			return true;
		},
		/**
		 * バリデーションメッセージをリセット ※必要に応じてオーバーライド <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function clearMessage
		 * @instance
		 */
		clearMessage:function(){
		},
		/**
		 * コードのバリデーションメッセージをリセット ※必要に応じてオーバーライド <br>
		 * ******* 内部処理 *******<br>
		 *
		 * @function clearMessage
		 * @instance
		 */
		clearMessageCode:function(){
		},
		//! 元データ更新イベント
		onUpdateSrcData:function(){
		},
		//! 必須項目の更新状態のチェック
		checkUpdateRequiredParam:function(name){
			if (this.r_is_new) {// 新規の場合は常に更新扱い
				return true;
			}
			return this.m_info[name]!=this.r_info[name]?true:false;
		},
		//! 必須ではない項目の更新状態のチェック
		checkUpdateParam:function(name){
			return this.m_info[name]!=this.r_info[name]?true:false;
		},
		//! 更新状態をチェックして、更新されていないなら更新フラグをリセットする
		updateChangeDataFlagSub:function(arrRequired,arrParam){
//console.log("updateChangeDataFlagSub : ");
			for(var i=0;i<2;i++){
				var arr=arrRequired;
				var func = this.checkUpdateRequiredParam;
				if(i==1){
					arr=arrParam;
					func = this.checkUpdateParam;
				}

				for(var key in arr){
					if(this.$refs[key] && typeof this.$refs[key]["setUpdate"] == "function"){
						var b = false;
						if(typeof arr[key] == "string"){
							b = func(arr[key]);
							this.$refs[key].setUpdate(b);
//console.log(key + ".setUpdate(" + b + ")");
						}else{
							for(var  key2 in arr[key]){
								var name = arr[key][key2];
								if(func(name)){
									// 更新された項目が一つでも存在
									b=true;
									break;
								}
							}
							this.$refs[key].setUpdate(b);
						}
					}else{
console.log("updateChangeDataFlagSub - unknown : " + key);
console.log("setUpdate = " + (typeof this.$refs[key]["setUpdate"]));
					}
				}
			}
		},
		onWatchInfo:function(val){
			console.log("onWatchInfo - r_info");
			this.onSrcChange(val);
			this.clearMessageCode();
			if(this.r_is_new == false){
				// 既存データの切り替わりのみ反映
				// 複製を作成
				//console.log("[ watch r_info ]");
				this.clearMessage();
				this.m_bCopy = false;
				this.m_info = $.extend(true,{},this.r_info);

				this.onUpdateSrcData();
				this.$nextTick(function() {
					// 申請者コメントの再適用
					this.restoreApplicantComment();
					//! データ更新フラグの更新
					// refsに関数内でアクセスするため、DOMに画表された後に行う
					this.updateChangeDataFlag();
				});
			// 新規データ
			} else {
				// 新規時の項目リセット対応
				this.clearMessage();
				this.m_bCopy = false;
				this.m_info = $.extend(true,{},this.r_info);

				this.onUpdateSrcData();
				this.$nextTick(function() {
					// 申請者コメントの再適用
					this.restoreApplicantComment();
					//! データ更新フラグの更新
					// refsに関数内でアクセスするため、DOMに画表された後に行う
					switch (this.r_settings.user.display_id) {
						// 管理会社マスター画面
						case '040000000000':
							break;
						// ディーラーマスター
						case '040000010000':
							break;
						default:
							this.updateChangeDataFlag();
					}
					// this.updateChangeDataFlag();
				});
			}
		},
		// 申請者コメントの待避
		backupApplicantComment:function(info){
			// 申請コメント、適用日を待避
			this.m_bRestoreApplicantComment = true;
			this.m_strApplicantComment = info.applicant_comment;
			this.m_strDateFrom = info.date_from;
			this.m_strDateTo = info.date_to;
		},
		// 申請者コメントの再適用
		restoreApplicantComment:function(){
			if (this.m_bRestoreApplicantComment) {
				// 退避した申請者コメント、適用日を適用
				this.m_info.applicant_comment = this.m_strApplicantComment;
				this.m_info.date_from = this.m_strDateFrom;
				this.m_info.date_to = this.m_strDateTo;
				// 退避した申請者コメント、適用日をクリア
				this.m_strApplicantComment = '';
				this.m_strDateFrom = '';
				this.m_strDateTo = '';
				this.m_bRestoreApplicantComment = false;
			}
		},
/*		※※※ updateChangeDataFlagSub の実装例 ※※※ 
		//! 確定後に更新フラグを更新 
		updateChangeDataFlag:function(){
			if(this.$refs.v_company_code){
				this.$refs.v_company_code.setUpdate(this.r_is_new);
			}
			//! 必須項目
			var arrRequired = {"v_disp_text":"company_name",		//!< 企業名
								"v_cmapany_char":"company_char",	//!< 識別コード
								};

			var arrParam ={	"v_csi_company_code":"csi_company_code",
							"v_sales_name":"sales_name",
							"v_address":["zip_code","address1","address2"],
							"v_user_note":"user_note",
							"v_note":"note",
							};

			this.updateChangeDataFlagSub(arrRequired,arrParam);
		},
*/
		checkChangeItem:function(info, key){
			var is = false;
			if ( info[key] == true ) {
				is = true;
			}
			return is;
		},
		/**
		 * マスターの表示用文言生成
		 */
		displayMasterText: function(code, text){
			let displayText = '';
			if(Number(code) > 0){
				// マスターの場合は「コード:名称」の形式で表示する
				displayText = String(code).padStart(String(this.r_settings.codes.main.max).length, '0') + ':' + text;
			}else{
				displayText = text;
			}
			return displayText;
		},
		/**
		 * キーとなるコードが入力済みかどうかの判定
		 */
		setDisableForKeyCode: function(code1, code2, plulink){
			var is = true;
			if (!plulink) {
				is = (code1 == "") ? true : false;
			} else {
				is = (code1 == "" || code2 == "") ? true : false;
			}
			this.m_isEmptyCode = is;
		},

	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/viewParamBase.mixin.vue